// pagarme.ts

export interface CardDetails {
    number: string
    holder_name: string
    exp_month: string
    exp_year: string
    cvv: string
    label: string
}

class PagarMeAPI {
    private baseUrl: string
    private apiKey: string

    constructor() {
        this.baseUrl = 'https://api.pagar.me/core/v5'
        this.apiKey = process.env.REACT_APP_KEY_PAGARME||''
    }

    private async request(method: string, endpoint: string, data?: any) {
        const options: RequestInit = {
            method: method,
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
            },
            body: data ? JSON.stringify(data) : undefined,
        }

        const response = await fetch(`${this.baseUrl}${endpoint}?appId=${this.apiKey}`, options)
        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`)
        }
        return response.json()
    }

    async generateToken(cardDetails: CardDetails) {
        const data = {
            type: 'card',
            card: cardDetails,
        }
        return this.request('POST', '/tokens', data)
    }

    async post(endpoint: string, data: any) {
        return this.request('POST', endpoint, data)
    }

    async get(endpoint: string) {
        return this.request('GET', endpoint)
    }

    async put(endpoint: string, data: any) {
        return this.request('PUT', endpoint, data)
    }

    async delete(endpoint: string) {
        return this.request('DELETE', endpoint)
    }
}

const pagarMeAPI = new PagarMeAPI()

export default pagarMeAPI
